import { render, staticRenderFns } from "./StatusHistoryTab.vue?vue&type=template&id=d5a46d98&scoped=true&"
import script from "./StatusHistoryTab.vue?vue&type=script&lang=js&"
export * from "./StatusHistoryTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5a46d98",
  null
  
)

export default component.exports